import { createSelector } from '@ngrx/store';
import { getHistoryOrderByOrderGUID } from '../getHistoryOrderByOrderGUID';

export const getHistoryOrderType = (orderGUID: string) => createSelector(getHistoryOrderByOrderGUID(orderGUID), (order) => order?.data?.OrderTypeId || null);
